import Services from "../../services";

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get("hrdu/approval_pemasukan/list", { params });
  }

  getHistory(params) {
    return Services.get("hrdu/approval_pemasukan/history/list", { params });
  }

  getSingle(params) {
    return Services.get("hrdu/approval_pemasukan/detail", { params });
  }

  approve(data) {
    return Services.post("hrdu/approval_pemasukan/approve", data);
  }
}

export default new PengakuanHutangApi();
